export class Form {

    submitBtn;

    constructor(formId, actionUrl, method) {
        this.formId = formId;
        this.actionUrl = actionUrl;
        this.method = method;
        this.form = document.querySelector(`#${formId}`);

    }

    collectData() {}

    async submit() {

        const result = await fetch(this.actionUrl, {
            method: this.method,
            body: JSON.stringify(this.collectData()),
            headers: { 'Content-Type': 'application/json' }
        });

        if (result.ok) this.successCallback();
        else this.errorCallback();
    }

    successCallback() {}
    errorCallback() {}

    listners() {
        this.submitBtn?.addEventListener('click', () => { this.submit() });
    }
}
